"use strict";

const sortKeyUtils = function (options?) {
    options = options || {};
    const chars: string = options.chars || "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
    const base = chars.length;

    var digitToCharMap = Array.from(chars).sort().map(c => c.charCodeAt(0)).map(c => String.fromCharCode(c));
    var charToDigitMap = digitToCharMap
        .map((c, i) => [c, i])
        .reduce((acc, curr) => {acc[curr[0]] = curr[1]; return acc;}, {});

    const charToDigit = (c) => {
        if (!(c in charToDigitMap)) {
            throw new Error("charToDigit: Invalid character: " + c);
        }
        return charToDigitMap[c];
    };

    const digitToChar = (i) => {
        if (!(("" + i) in digitToCharMap)) {
            throw new Error("digitToChar: Invalid integer: " + i);
        }
        return digitToCharMap[i];
    };

    const stringToDigitArray = function (str) {
        return Array.from(str).map(charToDigit);
    };

    const mid = (s1, s2) => {
        let arr1 = stringToDigitArray(s1);
        let arr2 = stringToDigitArray(s2);

        //console.log(arr1, arr2);

        let arrSum = [];
        let decimalPointAdjust = 0;
        let sumCarry = 0;
        for (let i = Math.max(s1.length, s2.length) - 1; i >= 0; i--) {
            let d1 = (i < arr1.length && i >= 0) ? arr1[i] : 0;
            let d2 = (i < arr2.length && i >= 0) ? arr2[i] : 0;
            let tempSum = d1 + d2 + sumCarry;
            arrSum.unshift(tempSum % base);
            sumCarry = Math.floor(tempSum / base);
        }
        //console.log("arrSum", arrSum);
        while(sumCarry !== 0) {
            arrSum.unshift(sumCarry % base);
            sumCarry = Math.floor(sumCarry / base);
            decimalPointAdjust++;
        }
        //console.log("arrSum", arrSum, decimalPointAdjust);

        let remainder = 0;
        let arrMid = [];
        for (let i = 0; i < arrSum.length || remainder !== 0; i++) {
            var numberToDivide = remainder * base + (i < arrSum.length ? arrSum[i] : 0);
            remainder = numberToDivide % 2;
            const ans = Math.floor(numberToDivide/2);
            //console.log("numberToDivide", numberToDivide, "ans", ans, "remainder", remainder)
            arrMid.push(ans);
        }

        while(arrMid[arrMid.length - 1] === 0) {
            arrMid.pop();
        }

        while(decimalPointAdjust > 0) {
            decimalPointAdjust--;
            let discard = arrMid.shift();
            //console.log("discard", discard);
        }

        //console.log(arrMid);
        //console.log(arrMid.map(digitToChar));
        const sMid = arrMid.map(digitToChar).join("");
        if ([s1, s2, sMid].sort()[1] != sMid) {
            console.log("Error!", [s1, s2], sMid);
            throw new Error();
        }
        return sMid;
    };


    return {
        mid: mid,
        minChar: digitToChar(0),
        maxChar: digitToChar(base - 1)
    };
};

export default sortKeyUtils;
